/* eslint-disable react-hooks/exhaustive-deps */
import { Typography, Button } from '@mui/material'
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SearchOutlinedIcon, KeyboardArrowDownOutlinedIcon } from '../../Assets'
import { GetServicesAction } from '../../Store/Actions/GetActions'
import styles from './FilterSider.module.css'

const FilterSideBar = ({
    handlefilterBySearch,
    handlesortBySearch,
    handleSearchByCity,
    handleSearchByService,
    filterObj,
    setFilterObj,
}) => {
    const [openNew, setOpenNew] = useState(false)
    const [openServices, setOpenServices] = useState(false)

    const handleSortSearch = (value) => {
        setFilterObj({
            ...filterObj,
            sort: value,
        })
        handlesortBySearch(value)
        setOpenNew(!openNew)
    }

    const dispatch = useDispatch()
    const { servicesdata } = useSelector((state) => state.ServicesReducer)
    useEffect(() => {
        dispatch(GetServicesAction())
    }, [])

    const serviceSelect = (service) => {
        setFilterObj({
            ...filterObj,
            service: [service],
        })
        handleSearchByService(service)
        setOpenServices(false)
    }

    const handleResetFilters = () => {
        // Reset all filter fields to their default values
        setFilterObj({
            search: '',
            sort: '',
            city: '',
            service: [],
        })
        
        // Close any open dropdowns
        setOpenNew(false)
        setOpenServices(false)
        
        // Trigger search with reset filters if search function exists
        if (handlefilterBySearch) {
            // Create a synthetic event to trigger search
            const resetEvent = { preventDefault: () => {} }
            handlefilterBySearch(resetEvent)
        }
    }

    const [maxLengths, setMaxLengths] = useState({})
    const inputRefs = useRef([])

    useEffect(() => {
        const updateMaxLength = (index) => {
            const inputWidth = inputRefs.current[index]?.clientWidth
            const avgCharWidth = 8
            const estimatedMaxLength = Math.floor(inputWidth / avgCharWidth)

            setMaxLengths((prev) => ({
                ...prev,
                [index]: estimatedMaxLength,
            }))
        }

        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry, index) => {
                updateMaxLength(index)
            })
        })

        inputRefs.current.forEach((input) => resizeObserver.observe(input))
        inputRefs.current.forEach((input, index) => updateMaxLength(index))

        return () => resizeObserver.disconnect()
    }, [])

    const truncatePlaceholder = (text, maxLength) =>
        text.length > maxLength - 2
            ? text.substring(0, maxLength - 3) + '...'
            : text

    return (
        <section className={styles.sideBarWrapper}>
            <div className={styles.myJobHeader}>
                <div>
                    <Typography variant="h6" fontWeight={'bold'}>
                        Filter Jobs
                    </Typography>
                </div>
            </div>
            {handlefilterBySearch && (
                <form
                    onSubmit={handlefilterBySearch}
                    className={styles.inputFields}
                >
                    <label htmlFor="searchByProjectName">
                        Search By Project Name
                    </label>
                    <div className={styles.searchInput}>
                        <input
                            type="text"
                            id="searchByProjectName"
                            ref={(el) => (inputRefs.current[0] = el)}
                            value={filterObj?.search}
                            placeholder={truncatePlaceholder(
                                'Search by Project name',
                                maxLengths[0] || 500
                            )}
                            onChange={(e) =>
                                setFilterObj({
                                    ...filterObj,
                                    search: e.target.value,
                                })
                            }
                        />
                        <button type="submit" className={styles.searchIcon}>
                            <SearchOutlinedIcon />
                        </button>
                    </div>
                </form>
            )}
            {handlesortBySearch && (
                <div className={styles.dropDown}>
                    <label htmlFor="">Sort By New/Old</label>
                    <div
                        className={styles.customDropDown}
                        onClick={() => setOpenNew(!openNew)}
                    >
                        <p>{filterObj?.sort || 'Select'}</p>
                        <KeyboardArrowDownOutlinedIcon />
                    </div>

                    {openNew && (
                        <div className={styles.customOption}>
                            <ul>
                                <li onClick={() => handleSortSearch('newest')}>
                                    Newest
                                </li>
                                <li onClick={() => handleSortSearch('oldest')}>
                                    Oldest
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            )}
            {/* //LOCATION CITIES */}
            {handleSearchByCity && (
                <form
                    onSubmit={handlefilterBySearch}
                    className={styles.dropDown}
                >
                    <label htmlFor="searchByCity">Search By City</label>
                    <div className={styles.searchInput}>
                        <input
                            type="text"
                            id="searchByCity"
                            ref={(el) => (inputRefs.current[1] = el)}
                            value={filterObj?.city}
                            placeholder={truncatePlaceholder(
                                'Search by City',
                                maxLengths[1] || 500
                            )}
                            onChange={(e) =>
                                setFilterObj({
                                    ...filterObj,
                                    city: e.target.value,
                                })
                            }
                        />
                        <button type="submit" className={styles.searchIcon}>
                            <SearchOutlinedIcon />
                        </button>
                    </div>
                    {/* <div className={styles.searchCity}>
                        <input
                            placeholder="Search city"
                            onChange={(e) => handleSearchCity(e.target.value)}
                            // setSearchCity(e.target.value)
                            // value={searchCity}
                            onBlur={() => console.log('outside click')}
                        />
                        <KeyboardArrowDownOutlinedIcon />
                    </div> */}
                    {/* {openLocation && (
                        <>
                            <div className={styles.customOption}>
                                <ul>
                                    <li>Electric</li>
                                    <li>Plumbing</li>
                                </ul>
                            </div>
                        </>
                    )} */}
                    {/* <>
                        {USACities.length && (
                            <div className={styles.customOption}>
                                <ul>
                                    {USACities.map((city) => {
                                        return (
                                            <li key={city.id}>{city.label}</li>
                                        )
                                    })
                                </ul>
                            </div>
                        )}
                    </> */}
                </form>
            )}
            {/* ///SERVIES */}
            {handleSearchByService && (
                <div className={styles.dropDown}>
                    <label htmlFor="">Filter By Service</label>
                    <div
                        className={styles.customDropDown}
                        onClick={() => setOpenServices(!openServices)}
                    >
                        <p>{filterObj?.service?.[0] || 'Select'}</p>
                        <KeyboardArrowDownOutlinedIcon />
                    </div>

                    {openServices && (
                        <div
                            className={`${styles.customOption} ${styles.servicesDropDownWrapper}`}
                        >
                            <ul>
                                {servicesdata.length ? (
                                    servicesdata.map((service) => {
                                        return (
                                            <li
                                                key={service.id}
                                                onClick={() =>
                                                    serviceSelect(service.slug)
                                                }
                                            >
                                                {service.label}
                                            </li>
                                        )
                                    })
                                ) : (
                                    <li
                                    // onClick={() => handleSortSearch("newest")}
                                    >
                                        No services
                                    </li>
                                )}
                            </ul>
                        </div>
                    )}
                </div>
            )}
            
            {/* Reset Filters Button */}
            {(handlefilterBySearch || handlesortBySearch || handleSearchByCity || handleSearchByService) && <div className={styles.dropDown}>
                <Button
                    variant="outlined"
                    onClick={handleResetFilters}
                    fullWidth
                    sx={{
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        textTransform: 'none',
                        fontWeight: '500',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: 'rgba(25, 118, 210, 0.04)',
                        },
                    }}
                >
                    Reset Filters
                </Button>
            </div>}
        </section>
    )
}
FilterSideBar.propTypes = {
    handlefilterBySearch: PropTypes.func,
    handlesortBySearch: PropTypes.func,
    handleSearchByCity: PropTypes.func,
    handleSearchByService: PropTypes.func,
    filterObj: PropTypes.object,
    setFilterObj: PropTypes.func,
}

export default FilterSideBar
